import * as React from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import { Box } from '@mui/system';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import InfoPaymentLeft from './InfoPaymentLeft';
import InfoPaymentRight from './InfoPaymentRight';
import { withRouter, useHistory } from 'react-router-dom';
import { Button } from 'antd';
const InfoCustomerPayment = (props) => {
	const { text, address, name, issue, mailAddress, createAt, status, shop } =
		props;
	const [open, setOpen] = React.useState(false);
	const [state, setState] = React.useState({
		bottom: open,
	});
	const toggleDrawer = (anchor, open) => (event) => {
		if (
			event.type === 'keydown' &&
			(event.key === 'Tab' || event.key === 'Shift')
		) {
			return;
		}
		setOpen(true);
		setState({ ...state, [anchor]: open });
	};
	const handleKeyPress = (event) => {
		event.preventDefault();
		if (event.key === 'ESC') {
			setOpen(false);
		}
	};

	const list = (anchor, index) => (
		<Box
			key={index}
			sx={{ width: '100%' }}
			role="presentation"
			onClick={toggleDrawer(anchor, open)}
			onKeyDown={toggleDrawer(anchor, open)}
		>
			<List>{text}</List>
		</Box>
	);
	const history = useHistory();
	const handleDrawerClose = () => {
		setOpen(false);
		history.push('/customers');
	};

	return (
		<>
			<div className="md:w-8/12 mobile:w-screen mobile:box-border mx-auto my-4">
				<div className="">
					<div className="flex justify-between items-baseline">
						<div className="basis-8/12">
							<Button
								size="large"
								onClick={() => handleDrawerClose()}
								className="border p-2 mr-2 rounded btn-direct"
							>
								<ArrowBackIcon />
							</Button>
							<span className="text-base font-semibold">Barbra Churchill</span>
						</div>
						<div>
							<Button
								className="border p-2 mr-2 rounded btn-direct"
								size="large"
							>
								<ChevronLeftIcon />
							</Button>
							<Button className="border p-2 rounded btn-direct" size="large">
								<ChevronRightIcon />
							</Button>
						</div>
					</div>
				</div>
				<div className="flex my-4 gap-4 md:flex-wrap xl:flex-nowrap hidescroll mobile:flex-wrap">
					<div className="xl:w-2/3 md:w-full xl:overflow-scroll md:h-auto xl:h-screen hidescroll ">
						<InfoPaymentLeft name={name} address={address} issue={issue} />
					</div>
					<div className="xl:w-1/3 md:w-full mobile:w-full xl:overflow-scroll md:h-auto xl:h-screen hidescroll">
						<InfoPaymentRight
							name={name}
							address={address}
							mailAddress={mailAddress}
							status={status}
						/>
					</div>
				</div>
			</div>
		</>
	);
};
export default withRouter(InfoCustomerPayment);
